module.exports = __webpack_public_path__ + "static/media/TomSerpento.b9f8863e.jpg";